import React from 'react'

type InfoBadgeVariant = 'info' | 'neutral' | 'empty'

type InfoBadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  variant?: InfoBadgeVariant
  outline?: boolean
}

export function getInfoBadgeClassName(
  variant: InfoBadgeVariant = 'info',
  className = '',
  outline?: boolean
): string {
  const hasOutline = outline ?? variant === 'info'
  const variantClassName = variant === 'empty'
    ? 'border border-dashed border-[#94A3B8] bg-white text-gray-500'
    : variant === 'neutral'
      ? 'bg-[#E1E1E1] text-[#373737]'
      : 'bg-[#D8EFFF] text-[#0D47A1]'
  const outlineClassName = hasOutline && variant !== 'empty'
    ? 'border border-[#C7DEF6]'
    : ''

  return [
    'inline-flex max-w-full items-center rounded px-2 py-0.5 text-xs font-medium leading-4',
    variantClassName,
    outlineClassName,
    className,
  ].filter(Boolean).join(' ')
}

export const InfoBadge: React.FC<InfoBadgeProps> = ({
  variant = 'info',
  outline,
  className = '',
  children,
  ...props
}) => (
  <span className={getInfoBadgeClassName(variant, className, outline)} {...props}>
    {children}
  </span>
)

export default InfoBadge
